import React, { useMemo } from 'react'
import FilterCard from '../../../components/filter-card'
import useI18n from '../../../i18n/useI18n'
import { DASHBOARD_RANGE_OPTIONS, rangeFilterDefaults } from '../utils'

const RangeFilterCard = ({
  filters,
  onFilterChange,
  onFilterSubmit,
  onClearFilters,
  onRefresh,
  loading
}) => {
  const { t } = useI18n()

  const rangeOptions = useMemo(
    () =>
      DASHBOARD_RANGE_OPTIONS.map((option) => ({
        value: option.value,
        label: t(option.labelKey)
      })),
    [t]
  )

  const fields = useMemo(() => {
    const baseFields = [
      {
        type: 'select',
        name: 'range',
        placeholder: t('DASHBOARD_FILTER_RANGE_PLACEHOLDER'),
        icon: 'zmdi zmdi-calendar',
        options: rangeOptions,
        colSize: 'col-12'
      },
      {
        type: 'input',
        name: 'from',
        placeholder: t('DASHBOARD_FILTER_FROM_PLACEHOLDER'),
        inputType: 'date',
        icon: 'zmdi zmdi-calendar-check',
        disabled: filters.range !== 'custom',
        required: filters.range === 'custom',
        colSize: 'col-12'
      },
      {
        type: 'input',
        name: 'to',
        placeholder: t('DASHBOARD_FILTER_TO_PLACEHOLDER'),
        inputType: 'date',
        icon: 'zmdi zmdi-calendar-note',
        disabled: filters.range !== 'custom',
        required: filters.range === 'custom',
        colSize: 'col-12'
      }
    ]

    return baseFields
  }, [filters.range, t, rangeOptions])

  return (
    <FilterCard
      filters={filters}
      onFilterChange={onFilterChange}
      onFilterSubmit={onFilterSubmit}
      onClearFilters={onClearFilters}
      onRefresh={onRefresh}
      loading={loading}
      title="DASHBOARD_FILTER_TITLE"
      titleHide="DASHBOARD_FILTER_HIDE"
      titleShow="DASHBOARD_FILTER_SHOW"
      fields={fields}
      defaultFilters={rangeFilterDefaults}
      autoSubmitFields={[]}
    />
  )
}

export default RangeFilterCard

